/* eslint-disable */
/*eslint max-lines: 1000*/
(function ($) {
    $(document.body).on('added_to_cart, xoo_wsc_cart_updated', function () {
        let count = parseInt($('.xoo-wsc-items-count').text()),
            text = $('.icons-menu__item--cart').attr('data-text');

        if (count === 0) {
            $('.icons-menu__item--cart .items-count').text('');
            $('.bag-link .mobile-product-count').text('');
            $('.bag-link .decor').hide();
        } else {
            $('.icons-menu__item--cart .items-count').text(`${count} ${text}`);
            $('.bag-link .mobile-product-count').text(count);
            $('.bag-link .decor').show();
        }
    });

    let url = new URLSearchParams(location.search);
    document.addEventListener('touch', function (e) {
        if (e.target.classList.contains('xoo-wsc-chng')) {
            e.target.click();
        }
    });
    if (document.querySelectorAll('.xoo-wsc-modal .side-login__wrapper').length) {
        let iconChevronLeft = '<svg class="side-login__header-back" width="30" height="30"><use xlink:href="#chevron-left"></use></svg>',
            headerTitle = '';

        document.querySelectorAll('.icons-menu__item--account').forEach((menuItemAccount) => {
            menuItemAccount.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.xoo-wsc-cart-trigger').click();
                document.body.classList.toggle('xoo-wsc-container--login');
            });
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('xoo-wsc-cart-trigger') || e.target.classList.contains('xoo-wsc-basket') || e.target.classList.contains('xoo-wsc-bki')) {
                document.body.classList.remove('xoo-wsc-container--login');
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__button-open-login')) {
                document.querySelectorAll('.xoo-wsc-modal .side-login__signup-container').forEach((container) => {
                    container.style.display = 'none';
                });
                document.querySelectorAll('.xoo-wsc-modal .side-login__login-container').forEach((container) => {
                    container.style.display = 'block';
                });
                headerTitle = document.querySelector('.side-login__header-text').innerHTML;
                document.querySelector('.side-login__header-text').innerHTML = `${iconChevronLeft}<span class="side-login__header-text-span">${themeText.LOG_IN}</span>`;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__button-open-signup')) {
                document.querySelectorAll('.xoo-wsc-modal .side-login__signup-container').forEach((container) => {
                    container.style.display = 'block';
                });
                document.querySelectorAll('.xoo-wsc-modal .side-login__login-container').forEach((container) => {
                    container.style.display = 'none';
                });
                headerTitle = document.querySelector('.side-login__header-text').innerHTML;
                document.querySelector('.side-login__header-text').innerHTML = `${iconChevronLeft}<span class="side-login__header-text-span">${themeText.SIGN_UP}</span>`;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__button-open-form-login')) {
                document.querySelector('.xoo-wsc-modal .side-login__social-login-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__login-container').style.display = 'block';
                headerTitle = document.querySelector('.side-login__header-text').innerHTML;
                document.querySelector('.side-login__header-text').innerHTML = `${iconChevronLeft}<span class="side-login__header-text-span">${themeText.LOG_IN}</span>`;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__button-open-form-register')) {
                document.querySelector('.xoo-wsc-modal .side-login__social-login-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__register-container').style.display = 'block';
                headerTitle = document.querySelector('.side-login__header-text').innerHTML;
                document.querySelector('.side-login__header-text').innerHTML = `${iconChevronLeft}<span class="side-login__header-text-span">${themeText.SIGN_IN}</span>`;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__button-open-form-lost-password')) {
                document.querySelector('.xoo-wsc-modal .side-login__social-login-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__login-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__register-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__lost-password-container').style.display = 'block';
                headerTitle = document.querySelector('.side-login__header-text').innerHTML;
                document.querySelector('.side-login__header-text').innerHTML = `${iconChevronLeft}<span class="side-login__header-text-span">${themeText.FORGOT_PASS}</span>`;
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('side-login__header-back') || e.target.classList.contains('side-login__header-text')) {
                document.querySelectorAll('.xoo-wsc-modal .side-login__signup-container').forEach((container) => {
                    container.style.display = 'none';
                });
                document.querySelectorAll('.xoo-wsc-modal .side-login__login-container').forEach((container) => {
                    container.style.display = 'block';
                });
                document.querySelector('.xoo-wsc-modal .side-login__social-login-container').style.display = 'block';
                document.querySelector('.xoo-wsc-modal .side-login__form__login-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__register-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__form__lost-password-container').style.display = 'none';
                document.querySelector('.xoo-wsc-modal .side-login__header-text').innerHTML = `${headerTitle}`;
            }
        });
        if (url.get('password-reset') === '1') {
            window.addEventListener("load", () => {
                document.querySelector('.icons-menu__item--account').click();
                document.querySelector('.side-login__button-open-form-login').click();
            });
            jQuery(document.body).on('wc_fragments_refreshed', () => {
                document.querySelector('.side-login__button-open-form-login').click();
            });
        }
    }
})(jQuery);
